import {apiService} from '../apiService';
import type {
    LoungePricing,
    UpdateLoungePricingRequest,
    PricingTier,
    PricingTierCreateRequest,
    UpdatePricingTierRequest,
    MeetingRoomPricing,
    UpdateMeetingRoomPricingRequest,
} from 'shared-types';

export const pricingApi = {
    // Lounge pricing endpoints
    lounge: {
        getCurrent: (): Promise<LoungePricing | null> =>
            apiService.get('/pricing/lounge/current'),

        create: (data: UpdateLoungePricingRequest): Promise<LoungePricing> =>
            apiService.post('/pricing/lounge', data),

        update: (id: string, data: UpdateLoungePricingRequest): Promise<LoungePricing> =>
            apiService.put(`/pricing/lounge/${id}`, data),

        delete: (id: string): Promise<void> =>
            apiService.delete(`/pricing/lounge/${id}`),

        getHistory: (): Promise<LoungePricing[]> =>
            apiService.get('/pricing/lounge/history'),
    },

    // Pricing tier endpoints (workspace pricing)
    tier: {
        getCurrent: (workspaceType: string): Promise<PricingTier | null> =>
            apiService.get(`/pricing/workspace/current/${workspaceType}`),

        getHistory: (workspaceType: string): Promise<PricingTier[]> =>
            apiService.get(`/pricing/workspace/history/${workspaceType}`),

        create: (data: UpdatePricingTierRequest): Promise<PricingTier> =>
            apiService.post('/pricing/tier', data),

        createOrUpdate: (data: PricingTierCreateRequest): Promise<PricingTier> =>
            apiService.post('/pricing/tier', data),

        update: (id: string, data: UpdatePricingTierRequest): Promise<PricingTier> =>
            apiService.put(`/pricing/tier/${id}`, data),

        delete: (id: string): Promise<void> =>
            apiService.delete(`/pricing/tier/${id}`),
    },

    // Meeting room pricing endpoints
    meetingRoom: {
        getCurrent: (): Promise<MeetingRoomPricing | null> =>
            apiService.get('/pricing/meeting-room/current'),

        create: (data: UpdateMeetingRoomPricingRequest): Promise<MeetingRoomPricing> =>
            apiService.post('/pricing/meeting-room', data),

        update: (id: string, data: UpdateMeetingRoomPricingRequest): Promise<MeetingRoomPricing> =>
            apiService.put(`/pricing/meeting-room/${id}`, data),

        delete: (id: string): Promise<void> =>
            apiService.delete(`/pricing/meeting-room/${id}`),

        getHistory: (): Promise<MeetingRoomPricing[]> =>
            apiService.get('/pricing/meeting-room/history'),
    },
};